<script setup lang="ts">
import { jobCodesData } from '@/utils/PortalConstants';
import { getStrCell } from '@/utils/file';
import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';
import * as commonConstants from '@/constants/common';

// TODO
// v-lazy should hide only tooltip and shouldn't hide other content
// Where is the best place for v-lazy, getStrCell/EmDashPlaceholder. Is it here or in the table?

export interface Props {
  attributes: string[];
}
const props = withDefaults(defineProps<Props>(), {
  attributes: () => [],
});
</script>

<template>
  <div
    :class="$style.jobAttributeCollection"
    data-testid="jobAttributeCollection"
  >
    <template v-if="attributes.length">
      <span v-for="(attribute, index) in props.attributes" :key="attribute">
        <span>
          <KParentTooltip location="bottom" :offset="3">
            <!-- @vue-ignore -->
            {{
              jobCodesData[attribute]
                ? jobCodesData[attribute].description
                : commonConstants.EM_DASH
            }}
          </KParentTooltip>
          {{ attribute }}</span
        >{{ index < props.attributes.length - 1 ? ',' : '' }}
      </span>
    </template>
    <template v-else>
      {{ getStrCell() }}
    </template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.jobAttributeCollection {
}
</style>
